/**
 * Canonical Origin Utility — für PWA-Install-URLs, teilbare Links & Marketing.
 *
 * Bug-Historie: Bislang nutzte `installUrl()` `window.location.origin`, was dazu führte,
 * dass QR-Codes für PWA-Installation auf der Preview-Umgebung die falsche Domain
 * (`fuel-x-preview.preview.emergentagent.com`) speicherten. Der Kunde installierte
 * die App und landete für immer auf der Dev-URL statt der Produktion.
 *
 * Ab jetzt gilt: alle SHAREABLE-URLs (QR-Codes, teilbare Links, PWA-Install) nutzen
 * `canonicalOrigin()` — nicht `window.location.origin`.
 *
 * ENV: REACT_APP_CANONICAL_URL (z.B. https://fuelxcard.com)
 * Fallback: https://fuelxcard.com (Production-Domain hard-coded als Notausgang).
 */
const CANONICAL_DEFAULT = 'https://fuelxcard.com';

export function canonicalOrigin() {
  const env = (process.env.REACT_APP_CANONICAL_URL || '').replace(/\/+$/, '');
  return env || CANONICAL_DEFAULT;
}

/** Prüft ob wir gerade auf der Canonical-Domain sind (relevant für Install-Prompts). */
export function isOnCanonicalDomain() {
  if (typeof window === 'undefined') return true;
  try {
    return new URL(canonicalOrigin()).host === window.location.host;
  } catch { return false; }
}
